import { Box, Typography, useMediaQuery } from "@mui/material";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import NAV from "../utils/nav.const";
import NotFound from "../assets/images/NotFound.svg";
import theme from "../styles/styleTheme";

const NoMatch = () => {
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box
      height={"100vh"}
      justifyContent={"center"}
      display={"flex"}
      alignItems={"center"}
    >
      <Box
        justifyContent={"flex-start"}
        display={"flex"}
        alignItems={"center"}
        flexDirection={"column"}
      >
        <Box display={"flex"} flexDirection={"row"} alignItems={"flex-end"}>
          <img src={NotFound} height={110} alt="Verify Email" />
          <Typography
            variant="h1"
            color={"primary"}
            sx={{ fontSize: isSmallScreen ? 50 : 65, marginLeft: 3 }}
          >
            Error 404
          </Typography>
        </Box>
        <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
          <Typography
            paddingTop={4}
            variant="body1"
            marginBottom={1}
            sx={{ fontWeight: 500 }}
          >
            We konden de pagina die je zocht niet vinden.
          </Typography>
          <CustomLink to={"/" + NAV.PROPERTY_OVERVIEW}>
            <Typography variant="h5" color={"primary"}>
              Terug naar overzicht
            </Typography>

            <Box>
              <ExitToAppIcon
                sx={{
                  fontSize: 28,
                  marginLeft: 1,
                }}
                color="primary"
              />
            </Box>
          </CustomLink>
        </Box>
      </Box>
    </Box>
  );
};

export default NoMatch;

const CustomLink = styled(NavLink)`
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;
